import { Table as TableComponent } from "./components/table/table";
import { TableBody as Body } from "./components/table-body/table-body";
import { TableCell as Cell } from "./components/table-cell/table-cell";
import { TableHead as Head } from "./components/table-head/table-head";
import { TableHeadCell as HeadCell } from "./components/table-head-cell/table-head-cell";
import { TableRow as Row } from "./components/table-row/table-row";
import { TableInfiniteScroll as InfiniteScroll } from "./components/table-infinite-scroll";
import { TableFooter as Footer } from "./components/table-footer";

/**
 * @inner Только для использования в АРМ Администратора
 */
export const Table = Object.assign(TableComponent, {
  Body,
  Cell,
  Head,
  HeadCell,
  Row,
  Footer,
  InfiniteScroll,
});
